import 'jquery-ui/ui/widgets/datepicker.js';

function CollectionControl() {}

CollectionControl.Update = function(page) {
    $("#divLoading").show();
    $("#txtPage").val(page);

    $("#collectionsFilterForm").trigger("submit");

    return false;
}

$(document).ready(function() {
    //  CollectionControl.Update();
    $("#divLoading").hide();

    if ($("#txtStartDate").length > 0)
        $("#txtStartDate").datepicker();

    if ($("#txtEndDate").length > 0)
        $("#txtEndDate").datepicker();

    /*    $(".filter-type").on("change", function() {
           CollectionControl.Update(1);
       }); */

    $("#btnSearch").on("click", function(e) {
        CollectionControl.Update(1);
        e.preventDefault();
        return false;
    });

    $(".pagination")
        .find('.page-link')
        .on('click', function(e) {
            CollectionControl.Update($(this).data('page'));

            e.preventDefault();
            return false;
        });
});